import { Fragment } from "react";
import { Box, Card, Skeleton, Text } from "@chakra-ui/react";

interface InsightCardProps {
  label: string;
  value?: string | number | null;
  note?: string;
  styleState?: "info" | "success" | "warning" | "error"| null;
}

function InsightCard ({ label, value, note, styleState }: InsightCardProps) {
  const loading = value === undefined || value === null;
  return(
    <Card.Root size="sm" bg={"bg" + (styleState ? `.${styleState}` : "")} borderColor={"border" + (styleState ? `.${styleState}` : "")}>
      <Card.Body display="flex" flexDirection="column" gap="1" alignItems="flex-end">
        <Skeleton loading={loading} borderRadius="md" height="4">
          <Text textAlign="right" fontSize="xs" color="gray.600">{label}</Text>
        </Skeleton>
        <Skeleton loading={loading} borderRadius="md" height={loading ? "6" : "auto"} minW="12" w="full">
          <Text textAlign="right" fontSize="lg" fontWeight="600">
            {value}
          </Text>
          {note && (
            <Box display="flex" gap={["none", null, 1]} flexWrap="wrap" justifyContent="flex-end" fontSize="xs" fontWeight="400" lineHeight="1" opacity="0.8">
              {note.split(/ (?=±)/).map((part, i) => (
                <Fragment key={part}>
                  {i > 0 && (
                    <Text as="span" display={{ base: "none", md: "inline" }}>  ·  </Text>
                  )}
                  <Text as="span" whiteSpace="nowrap" textAlign="right" w={{ base: "full", md: "auto" }}>
                    {part}
                  </Text>
                </Fragment>
              ))}
            </Box>
          )}
        </Skeleton>
      </Card.Body>
    </Card.Root>
  );
}

export default InsightCard;
